export default "__VITE_ASSET__D3kyUiM2__"